import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Rules.css";
import click from "./assets/sounds/click.mp3";
import { usePreferences } from "./hooks/usePreferences";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

export default function Rules() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, game } = location.state || {};
  const token = localStorage.getItem("token") || "";
  const { soundEnabled, timerSoundEnabled } = usePreferences(token);
  const timerAudioRef = useRef(null); // 🔊 ref pour le son tic-tac
  const { t, i18n } = useTranslation();

    useEffect(() => {
      if (profile?.preferredLanguage) {
        i18n.changeLanguage(profile.preferredLanguage.toLowerCase());
      }
    }, [profile?.preferredLanguage]);

  const playSound = (sound, isTimer = false) => {
    if ((isTimer && !timerSoundEnabled) || (!isTimer && !soundEnabled)) return;

    if (isTimer) {
      // stoppe un éventuel son déjà lancé
      if (timerAudioRef.current) {
        timerAudioRef.current.pause();
        timerAudioRef.current.currentTime = 0;
      }
      timerAudioRef.current = new Audio(sound);
      timerAudioRef.current.loop = true; // tic-tac en continu
      timerAudioRef.current.play();
    } else {
      const audio = new Audio(sound);
      audio.play();
    }
  };

  return (
    <div className="rules-container">
      <h1>{t("rules.title")}</h1>
      <div className="rules-content">
    <Trans i18nKey="rules.content" components={{ p: <p />, ul: <ul />, li: <li />, strong: <strong /> }} />
      </div>
      <button className="back-btn-rules" onClick={() => {playSound(click);navigate(-1)}}>
        ←
      </button>
    </div>
  );
}
